import { Box, Container, Image, Text, Button } from '@chakra-ui/react'

export function PhotoPreview({ image, canResend, loading, onApprove, onRetake }) {
  return (
    <Box bgColor="#313E44" minH="100vh">
      <Container padding={6}>
        <Image src={image} width={'full'} height="auto" maxH="70vh" objectFit="contain" rounded={'2xl'} />

        <Text fontSize="lg" textTransform={'uppercase'} textAlign={'center'} my={4} color="white">
          Deseja usar esta foto ou tirar outra?
        </Text>

        <Button
          w={'full'}
          fontSize={'lg'}
          my={2}
          py={4}
          _focus={{ border: 'none' }}
          _active={{}}
          _hover={{
            bg: '#2cce7a',
            transform: 'none',
          }}
          bgColor={'#37F091'}
          color={'#313E44'}
          onClick={onApprove}
          isLoading={loading}
          loadingText="Processando..."
          fontWeight="bold"
        >
          {canResend ? 'Atualizar Foto' : 'Confirmar e Finalizar'}
        </Button>

        <Button
          w={'full'}
          fontSize={'lg'}
          my={2}
          py={4}
          _focus={{ border: 'none' }}
          _active={{}}
          _hover={{
            borderColor: '#37F091',
            transform: 'none',
          }}
          border={'1px solid #37F091'}
          bg="transparent"
          color={'#37F091'}
          onClick={onRetake}
        >
          Tirar Outra Foto
        </Button>
      </Container>
    </Box>
  )
}
